module.exports = __webpack_public_path__ + "img/commaful-star.2694e568.svg";